import React from "react";
import { FileUploader } from "./components";
import { types as FileUploaderTypes } from "./components/file-uploader/duck";

const FileInput: React.FC<FileUploaderTypes.FileUploaderProps> = ({
  containerClassName,
  name,
  uploadHint,
  uploadHintClassName,
  label,
  labelClassName,
  maxElements,
  maxFileSize,
  endpoint,
  allowedFilesExtensions,
  renderListItemCallback,
  fileForUploading,
  classNameFilesList,
}) => {
  return (
    <FileUploader
      containerClassName={containerClassName}
      allowedFilesExtensions={allowedFilesExtensions}
      name={name}
      uploadHint={uploadHint}
      uploadHintClassName={uploadHintClassName}
      label={label}
      labelClassName={labelClassName}
      maxElements={maxElements}
      maxFileSize={maxFileSize}
      endpoint={endpoint}
      renderListItemCallback={renderListItemCallback}
      fileForUploading={fileForUploading}
      classNameFilesList={classNameFilesList}
    />
  );
};

export default FileInput;
